"use client";

import { c as _c } from "react/compiler-runtime";
import { clsx } from "clsx";
import { type JSX, useEffect, useId } from "react";
import { useSiteConfiguration } from "@/contexts/site-configuration/site-configuration.context";
import { runCookiebotDeclarationScripts, runCookiebotScripts } from "@/vendors/Cookiebot/_components/CookiebotScript.component";
import { reinitializeFlourishEmbeds } from "@/vendors/Flourish/reinitialize-flourish";
import { runInlineScripts } from "./evaluate-inline-script";
type HtmlContentProps = {
  readonly className?: string;
  readonly html: string;
  readonly tag?: keyof JSX.IntrinsicElements;
};
export function HtmlContent(t0) {
  const $ = _c(17);
  const {
    className,
    html,
    tag: t1
  } = t0;
  const tag = t1 === undefined ? "div" : t1;
  const domId = useId();
  const TagComponent = tag;
  const {
    tracking
  } = useSiteConfiguration();
  const cookiebotId = tracking?.cookiebotId;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  useEffect(runCookiebotScripts, t2);
  let t3;
  let t4;
  if ($[1] !== domId) {
    t3 = () => {
      runInlineScripts(`#${CSS.escape(domId)}`);
      reinitializeFlourishEmbeds();
    };
    t4 = [domId];
    $[1] = domId;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[4] !== cookiebotId || $[5] !== domId) {
    t5 = () => runCookiebotDeclarationScripts(domId, cookiebotId);
    t6 = [cookiebotId, domId];
    $[4] = cookiebotId;
    $[5] = domId;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  useEffect(t5, t6);
  let t7;
  if ($[8] !== className) {
    t7 = clsx(className, "prose prose-gray wrap-break-word hyphens-manual");
    $[8] = className;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== html) {
    t8 = {
      __html: html
    };
    $[10] = html;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== TagComponent || $[13] !== domId || $[14] !== t7 || $[15] !== t8) {
    t9 = <TagComponent className={t7} dangerouslySetInnerHTML={t8} id={domId} />;
    $[12] = TagComponent;
    $[13] = domId;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}